// This function allow to reference chunks
__webpack_require__.miniCssF = function(chunkId) {
  // return url for filenames not based on template
  if (chunkId === 7888) return "css/design_system-48f925e8ad8f74e2.css";
if (chunkId === 1710) return "css/1710-0573bf035ed5dce9.css";
  // return url for filenames based on template
  return "css/" + chunkId + "-" + {1718: "25e43d52410aceac",2429: "6f1455158b7d42a3",3111: "8733c5905a498590",3641: "91ecc8e70b90fc55",370: "a8d311b114ec77ce",424: "25e43d52410aceac",5877: "5e7c04a2b0740134",9468: "fff606c4f8ef08bd",9483: "e671c92ef3054d4c",9590: "25e43d52410aceac",}[chunkId] + ".css"
}